export default class DtoSummarySurvey {
    constructor(obj) {
        this.id = obj.id // Option[Long] = None,
        this.year = obj.year // Option[Int] = None,
        this.name = obj.name // Option[String] = None,
        this.link_exploitations = obj.link_exploitations || [] // Option[Seq[Long]] = None

        this.nameWithYear = `${obj.name || ''} [${obj.year}]`
    }
}